import { render } from "./Steps.vue?vue&type=template&id=ffbf8fc0&scoped=true"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"

import "./Steps.vue?vue&type=style&index=0&id=ffbf8fc0&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffbf8fc0"]])

export default __exports__